import { api } from '../../core/network/api';

/**
 * design/gdd/leaderboards.md — the standings.
 *
 * `/leaderboards`, plural: the template's own core leaderboard already owns
 * `/leaderboard/:category`, and these are a different thing entirely — see the
 * backend controller on why this could not be a core category.
 */

export type LeaderboardModeId = 'DUNGEON' | 'ARENA' | 'WAVES';
export type LeaderboardSort = 'score' | 'winRate' | 'level';

/** Served rather than mirrored, for the reason `game-modes-api.ts` gives. */
export interface LeaderboardModeRow {
  mode: LeaderboardModeId;
  name: string;
  scoreLabel: string;
  scoreUnit: string;
  winMeans: string;
}

export interface LeaderboardEntryRow {
  rank: number;
  userId: string;
  username: string | null;
  matches: number;
  wins: number;
  losses: number;
  draws: number;
  bestScore: number;
  peakLevel: number;
  winRate: number;
  winRateRanked: boolean;
  characterId: string | null;
  characterClass: string;
  characterLevel: number;
  /** '' for the default look. */
  skinAssetKey: string;
}

export interface PersonalStandingRow {
  rank: number | null;
  total: number;
  matchesUntilRanked: number;
  aggregate: {
    userId: string; matches: number; wins: number; losses: number; draws: number;
    bestScore: number; peakLevel: number;
  } | null;
}

export interface LeaderboardBoard {
  mode: LeaderboardModeRow;
  sort: LeaderboardSort;
  limit: number;
  offset: number;
  total: number;
  rows: LeaderboardEntryRow[];
  me: PersonalStandingRow;
}

export const getLeaderboardModes = (): Promise<{ modes: LeaderboardModeRow[]; minMatchesForWinRate: number }> =>
  api.get('/leaderboards');

export const getLeaderboard = (
  mode: LeaderboardModeId, sort: LeaderboardSort, limit = 25, offset = 0,
): Promise<LeaderboardBoard> =>
  api.get(`/leaderboards/${mode}?sort=${sort}&limit=${limit}&offset=${offset}`);
